import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

export interface SidebarMenuItem {
  id: string;
  label: string;
  icon?: string;
  route: string;
}

@Component({
  selector: 'app-sidebar-layout',
  templateUrl: './sidebar-layout.component.html',
  styleUrls: ['./sidebar-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarLayoutComponent {
  @Input() public menuItems: SidebarMenuItem[] = [];
  @Input() public activeItemId = '';
  @Output() public itemSelected = new EventEmitter<SidebarMenuItem>();

  public selectItem(item: SidebarMenuItem): void {
    this.itemSelected.emit(item);
  }
}
